export const RECEIVE_ALERTS = 'RECEIVE_ALERTS';
export const SORT_ALERTS = 'SORT_ALERTS';
export const FILTER_ALERTS = 'FILTER_ALERTS';
export const FETCH_ONBOARDING_ALERT = 'FETCH_ONBOARDING_ALERT';
export const RESOLVE_ALERT = 'RESOLVE_ALERT';


// specific alert types
export const NEED_HELP_ALERT_SUBMITTED = 'NEED_HELP_ALERT_SUBMITTED';
export const NEED_HELP_ALERT_CREATED = 'NEED_HELP_ALERT_CREATED';
export const RESET_NEED_HELP_ALERT = 'RESET_NEED_HELP_ALERT';

export const BAD_WORK_ALERT_SUBMITTED = 'BAD_WORK_ALERT_SUBMITTED';
export const BAD_WORK_ALERT_CREATED = 'BAD_WORK_ALERT_CREATED';
export const RESET_BAD_WORK_ALERT = 'RESET_BAD_WORK_ALERT';

export const REVIEW_REQUEST_ALERT_SUBMITTED = 'REVIEW_REQUEST_ALERT_SUBMITTED';
export const REVIEW_REQUEST_ALERT_CREATED = 'REVIEW_REQUEST_ALERT_CREATED';

export const ALERT_INSTRUCTOR_INITIALIZE = 'ALERT_INSTRUCTOR_INITIALIZE';
export const ALERT_INSTRUCTOR_CREATE = 'ALERT_INSTRUCTOR_CREATE';
export const ALERT_INSTRUCTOR_FAILED = 'ALERT_INSTRUCTOR_FAILED';
export const ALERT_INSTRUCTOR_MODAL_VISIBLE = 'ALERT_INSTRUCTOR_MODAL_VISIBLE';
export const ALERT_INSTRUCTOR_MODAL_HIDDEN = 'ALERT_INSTRUCTOR_MODAL_HIDDEN';
export const ALERT_INSTRUCTOR_UPDATE_SUBJECT = 'ALERT_INSTRUCTOR_UPDATE_SUBJECT';
export const ALERT_INSTRUCTOR_UPDATE_BCC = 'ALERT_INSTRUCTOR_UPDATE_BCC';
export const ALERT_INSTRUCTOR_UPDATE_MESSAGE = 'ALERT_INSTRUCTOR_UPDATE_MESSAGE';

